module.exports = __webpack_public_path__ + "img/moto.5fe92c69.svg";